import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/bms-software/page.tsx");
